import * as React from 'react';
import { cn } from '../../utils.js';
import { inputVariants } from './input/input.js';
import { useRef } from 'react';
import { HStack } from '../HStack.js';
import { Label } from './label.js';
import { Text, textVariants } from '../Text.js';
import { VariantProps } from 'class-variance-authority';

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    VariantProps<typeof inputVariants> {
  label?: React.ReactNode;
  error?: React.ReactNode;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, className, ...props }, ref) => {
    const id = useRef(Math.random());
    return (
      <div className='grid w-full max-w-sm items-center gap-1'>
        {label && (
          <Label
            htmlFor={props.id ?? id.current.toString()}
            className={textVariants({
              font: 'regular-xs',
              color: error ? 'red' : 'gray-500',
            })}
          >
            {label}
          </Label>
        )}
        <HStack
          className={cn(
            inputVariants({
              variant: error ? 'error' : 'default',
              textarea: true,
              className: ' flex-grow items-center gap-2',
            }),
            className
          )}
        >
          <textarea
            id={props.id ?? id.current.toString()}
            className='w-full bg-transparent focus:outline-none'
            ref={ref}
            {...props}
          />
        </HStack>
        {error && (
          <Text color={'red'} font={'regular-xs'}>
            {error}
          </Text>
        )}
      </div>
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
